module.exports = __webpack_public_path__ + "static/media/menu_unavailable.af81d122.png";